let IndexFiltersMode;
(function (IndexFiltersMode) {
  IndexFiltersMode["Default"] = "DEFAULT";
  IndexFiltersMode["Filtering"] = "FILTERING";
  IndexFiltersMode["EditingColumns"] = "EDITING_COLUMNS";
})(IndexFiltersMode || (IndexFiltersMode = {}));

export { IndexFiltersMode };
